var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.element,{tag:"component",domProps:{"innerHTML":_vm._s(_vm.nl(_vm.text))}})}
var staticRenderFns = []

export { render, staticRenderFns }